<template>
  <div>
    <button
            data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false" class="dropdown-toggle three-dots-position-action" @click="load">
        <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z" fill="#2E4051"/>
        </svg>

    </button>

    <ul class="dropdown-menu dropdownActionsMenuCusList pair_of_all_li"
        :aria-labelledby="'dropdonwActionsMenu'+customer_id" style="z-index: 99999998;top: 20px"
        :id="'actionsMenuByHover'+customer_id">


        <li>
            <a :href="customerViewHref" target="_blank"><span><i class="fa fa-user" aria-hidden="true"></i></span>
                View customer profile </a>
        </li>
        <li>
            <a data-toggle="modal" data-target="#create_edit_customer_popup" href="#"
               class="details_info_opt" @click="sendCustomerId">
                <span><i class="fa fa-pencil"></i></span>
                <span>Edit customer details</span>
            </a>
        </li>

        <li v-if="fromViewPage">
            <a data-toggle="modal" :data-target="`#changeCustomerPopup_${customer_id}`" href="#"
               class="details_info_opt">
                <span><i class="fa fa-pencil"></i></span>
                <span>Change customer</span>
            </a>
        </li>

        <li>
            <a :href="mergeHref"
               class="details_info_opt" target="_blank">
                <span><i class="fa fa-compress"></i></span>
                <span>Merge duplicate profiles</span>
            </a>
        </li>


        <li>
            <a href="#" data-toggle="modal" data-target="#popupi"
               @click="callPopupiAction('Import Customer properties',ImportCustomerPropertiesClickConfirm);"
               class="details_info_opt">
                <span><i class="fa fa-download"></i>  </span>
                <span>Import customer properties</span>
            </a>
        </li>

        <hr class="uniq_hr_style">

      <li><a href="#" data-toggle="modal" data-target="#popupi"
             @click="callPopupiAction('View statement',customerStatment);"
             class="details_info_opt">
        <span><i class="fa fa-file-text"></i></span>
        <span>View statement</span>
      </a></li>

      <li><a href="#" data-toggle="modal" data-target="#popupi"
             @click="callPopupiAction('Billing Cycle',editBillingCyclePopup);"
             class="details_info_opt">
        <span><i class="fa fa-clock-o"></i></span>
        <span v-if="hasBillingCycle" >Edit Billing Cycle</span>
        <span v-else>Add Billing Cycle</span>

      </a></li>
      <hr class="uniq_hr_style">

      <li v-show="hasCustomerLabelCredential">
        <a
           :data-toggle="!fromViewPage ? 'modal' : null"
           :data-target="!fromViewPage ? '#popupi' : null"
           href="#"
           @click="handleAddLabelClick"
           class="details_info_opt">
          <span><i class="fa fa-tag"></i></span>
          <span>Add label</span>
        </a>
      </li>
      <li>
        <a :href='addPaymentMethodUrl'>
                             <span>
                             <i class="fa fa-money" aria-hidden="true"></i></span><span>Add payment method</span></a>
        </li>
        <li>
            <a href="#" data-toggle="modal" data-target="#popupi"
               @click="callPopupiAction('Set Invoice Due Date',setInvoiceDueDateConfirm);"
               class="details_info_opt">
                <span><i class="fa fa-clock-o"></i></span><span> Set Invoice due date</span>
            </a>
        </li>

        <hr class="uniq_hr_style">

      <li v-show="support_team_has_login_permission">
        <a href="#"
           @click="confirmDeleteCustomerList('Are you sure you want to Login to this Company ?')">Login
          To This Company
        </a>
      </li>
      <li>
        <a @click.stop="smsConfirmAction">
          <span><i class="fa fa-comments"></i>  </span>
          <span>{{ smsText }}</span>
        </a>
      </li>
<!--      <li>-->
<!--        <a @click.stop="mailConfirmAction">-->
<!--          <span><i class="fa fa-comments"></i>  </span>-->
<!--          <span>Pause email</span>-->
<!--        </a>-->
<!--        <hr class="uniq_hr_style">-->
<!--      </li>-->
      <li v-show="hasCustomerDeleteCredential">
        <a href="#" @click="deleteLink(customer_id,customer_name, link_delete_new);" class="details_info_opt "
           style="color: red !important;">
        <span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true"
                   focusable="false" width="0.92em" height="1em" preserveAspectRatio="xMidYMid meet"
                   viewBox="0 0 1408 1536" class="iconify" data-icon="fa:trash-o" data-inline="false"
                   style="transform: rotate(360deg);"><path
            d="M512 608v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23V608q0-14 9-23t23-9h64q14 0 23 9t9 23zm256 0v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23V608q0-14 9-23t23-9h64q14 0 23 9t9 23zm256 0v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23V608q0-14 9-23t23-9h64q14 0 23 9t9 23zm128 724V384H256v948q0 22 7 40.5t14.5 27t10.5 8.5h832q3 0 10.5-8.5t14.5-27t7-40.5zM480 256h448l-48-117q-7-9-17-11H546q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5H288q-66 0-113-58.5T128 1336V384H32q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"
            fill="currentColor"></path></svg></span>
          <span>Delete</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import {getCustomerDropDownActions} from "@/modules/common/api";
import {EventBus} from "@/events/event-bus";

export default {
  name: "CustomerActionsDropDown",
  props: {
    customer_id: '',
    link_delete_new: '',
    fromViewPage:{
        default(){
            return false
        }
    }
  },
  data() {
    return {
      customerStatment: '',
      hasShowDeletedAndUnDeleteCredential: null,
      hasCustomerDisscussionCredenetial:null,
      customer_name: null,
      hasShowDeletedAndDeleteForeverCredential: null,
      sendMailPopupConfig: null,
      onclickConfirmDelete: null,
      sendEmailAuth: null,
      sendSmsPopupConfig: null,
      support_team_has_login_permission: null,
      customerLoginHref: null,
      customerViewHref: null,
      mergeHref: null,
      editCustomerPopup: null,
      editBillingCyclePopup: null,
      hasBillingCycle: null,
      hasCustomerLabelCredential: null,
      AddLabelPopupConfig: null,
      addPaymentMethodUrl: null,
      setInvoiceDueDateConfirm: null,
      ImportCustomerPropertiesClickConfirm: null,
      hasCustomerDeleteCredential: null,
      getDropDownElementsUrl: '',
      isDeleted: false,
      smsHref: '',
      smsConfirm: '',
      smsText: '',
      mailHref: '',
      mailConfirm: '',
      mailText: '',
      companyHasTwilioAccount: false,
      customerNumbers: '',
      twilioLink: '',
    }
  },
  created() {

  },
  methods: {
    load() {
      let vm = this;
      //add show deleted = 0 as filter to prevent view soft deleted images
      getCustomerDropDownActions(this.customer_id)
          .then(function (response) {

            vm.hasShowDeletedAndUnDeleteCredential = response.data.hasShowDeletedAndUnDeleteCredential
            vm.customer_name = (response.data.customerData.first_name + response.data.customerData.last_name).toString()
            vm.hasShowDeletedAndDeleteForeverCredential = response.data.hasShowDeletedAndDeleteForeverCredential
            vm.sendMailPopupConfig = response.data.sendMailPopupConfig
            vm.onclickConfirmDelete = response.data.onclickConfirmDelete
            vm.sendEmailAuth = response.data.sendEmailAuth
            vm.customerStatment = response.data.customerStatment
            vm.support_team_has_login_permission = response.data.customerData.support_team_has_login_permission
            vm.customerLoginHref = response.data.customerLoginHref
            vm.customerViewHref = response.data.customerViewHref
            vm.mergeHref = response.data.mergeHref
            vm.editCustomerPopup = response.data.editCustomerPopup
            vm.editBillingCyclePopup = response.data.editBillingCyclePopup
            vm.hasBillingCycle = response.data.hasBillingCycle
            vm.hasCustomerLabelCredential = response.data.hasCustomerLabelCredential
            vm.AddLabelPopupConfig = response.data.AddLabelPopupConfig
            vm.addPaymentMethodUrl = response.data.addPaymentMethodUrl
            vm.setInvoiceDueDateConfirm = response.data.setInvoiceDueDateConfirm
            vm.ImportCustomerPropertiesClickConfirm = response.data.ImportCustomerPropertiesClickConfirm
            vm.hasCustomerDeleteCredential = response.data.hasCustomerDeleteCredential
            vm.getDropDownElementsUrl = response.data.getDropDownElementsUrl
            vm.smsHref = response.data.smsHref
            vm.smsConfirm = response.data.smsConfirm
            vm.smsText = response.data.smsText
            vm.mailHref = response.data.mailHref
            vm.mailConfirm = response.data.mailConfirm
            vm.mailText = response.data.mailText
            vm.sendSmsPopupConfig = response.data.sendSmsPopupConfig
            vm.customerNumbers = response.data.customerNumbers
            vm.companyHasTwilioAccount = response.data.companyHasTwilioAccount
            vm.twilioLink = response.data.twilioLink
                /** when the admin clicks to action button scroll 200px or scrolls to the same height as ul
                 * ul id ???? $(".dropdownActionsMenuCusList")
                 * plus 50 px to add space below the ul
                 * 1000 ??? animate  speed
                 * **/
              // $("table").animate({ scrollTop: $(".dropdownActionsMenuCusList").height() + 50 }, 1000);


          })
    },
    sendCustomerId(){
        EventBus.$emit('setCustomerId', this.customer_id);
    },
    callPopupiAction(text, action) {
      window.popupi(text, action);
    },
    unDeleteLink(id, name) {
      window.unDeleteLink(id, name)
    },
    confirmDeleteCustomerList(onclickConfirmDelete) {
      let url = this.customerLoginHref;
      if (typeof window.confirmDeleteCustomerList === "function") {
        if (url){
          window.confirmDeleteCustomerList(url,onclickConfirmDelete)
        }
        else {
          window.confirmDeleteCustomerList(onclickConfirmDelete)
        }
      }


    },
    deleteLink(id, customer_name, link_delete_new) {
      window.deleteLink(id, customer_name, link_delete_new)
    },
    smsConfirmAction() {
      if (confirm(this.smsConfirm)) {
          let vm = this;
          return window.axios.post(vm.smsHref+'?vue=1').then(function (response) {
              vm.load();
          });
      }
    },
    mailConfirmAction() {
      if (confirm(this.mailConfirm)) {
        window.location.href = this.mailHref;
      }
    },

    regularCallPopup() {
      if (this.companyHasTwilioAccount) {
        window.regularCallPopup("choose", null, this.twilioLink, this.customer_name, this.customerNumbers)
      } else {

        window.regularCallPopup("web", null, null, this.customer_name, this.customerNumbers)
      }
    },
    handleAddLabelClick(){
        if (!this.fromViewPage){
        this.callPopupiAction('Customer Label',this.AddLabelPopupConfig);
        }
        else {
            EventBus.$emit('addLabelPopupOpen','customer')

        }
    },
  }
}

</script>

<style>
.actions-btn{
  display: flex!important;
  align-items: center;
  justify-content: center;
  border-radius: 50%!important;
  padding: 0!important;
  width: 32px !important;
  height: 32px !important;
  line-height: 2.2 !important;

}
.three-dots-position-action {
    display: inline-block;
    cursor: pointer;
    position: relative;
    margin-left: -11px;
    border-radius: 50%;
    padding-right: 12px;
    padding-left: 10px;
    border: none;
    padding-top: 2px;
    background: transparent;

}

.three-dots-position-action:hover::before {
    content: '';
    position: absolute;
    left: 45%;
    top: 45%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    background-color: rgba(128,128,128,0.3);
    border-radius: 50%;
    z-index: 0;
    color: black;
}
.open .three-dots-position-action::before{
    background-color: #bababa8c !important;
    content: '';
    position: absolute;
    left: 45%;
    top: 45%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    z-index: 0;
    color: black;
}
.dropdown-menu.dropdownActionsMenuCusList.pair_of_all_li {
    margin-left: -290px;
}
@media screen and (max-width: 768px) {
    .dropdown-menu.dropdownActionsMenuCusList.pair_of_all_li {
        margin-left: -238px;
    }
    .three-dots-position-action {
        margin-left: -10px;
    }
}

</style>